/**
 * Copyright © 2026 Adnuntius AS.
 *
 * Marker class only — keep this file free of session/auth imports so
 * LocalNetworkProfile can depend on this token without an ES-module cycle.
 */
/** Angular DI token for the NetworkProfile HTTP resource (factory product). */
export class NetworkProfileResource {
}
